const ABOUT_IMG = "/assets/portrait-guillaume-pascal.jpg";

export default function Agence() {
  return (
    <div data-testid="page-agence">
      <PageHero
        overline="Notre agence"
        title="Un cabinet à taille humaine."
      />

      <section className="py-16 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-5">
              <img src={ABOUT_IMG} alt="Guillaume Pascal, fondateur du Cabinet GPI" className="w-full aspect-[4/5] object-cover" />
              <div className="mt-4 font-overline text-[#94A3B8] text-[10px]">
                — Guillaume Pascal
              </div>
            </div>
            <div className="lg:col-span-7 space-y-6 lg:pt-12">
              <span className="font-overline-lg text-[#B8935A]">Histoire</span>
              <div className="text-[#475569] leading-relaxed space-y-4 text-[1.05rem]">
                <p>
                  Implanté à Marseille, le Cabinet GPI accompagne les acteurs de l’immobilier et de la copropriété
                  dans leurs problématiques de gestion, d’administration, de comptabilité et d’expertise.
                </p>
                <p>
                  Son activité repose sur une expérience de terrain acquise au sein du secteur immobilier,
                  complétée par une formation supérieure associant une Licence en gestion immobilière, un BTS
                  Professions Immobilières et un Master en sciences diplomatiques.
                </p>
                <p>
                  Le Cabinet intervient principalement dans l’administration de copropriétés, la gestion
                  d’immeubles et l’accompagnement des syndicats de copropriétaires et des associations
                  syndicales libres (ASL). Cette pratique quotidienne permet d’appréhender avec précision
                  les enjeux juridiques, techniques et financiers liés au fonctionnement des ensembles
                  immobiliers.
                </p>
                <p>
                  Par ailleurs, Guillaume PASCAL, président du Cabinet GPI, est inscrit sur la liste des
                  experts judiciaires près la Cour d’appel d’Aix-en-Provence dans la rubrique C-19.01
                  « Administration d’immeuble et de copropriété, baux d’habitation, commerciaux et
                  professionnels ». À ce titre, il intervient dans le cadre de missions d’expertise portant
                  notamment sur la gestion des copropriétés, l’administration immobilière et les litiges dans
                  le cadre des procédures d’administration provisoire (articles 47 du décret du 17 mars 1967
                  ou 29-1 de la loi du 10 juillet 1965).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="font-overline-lg text-[#B8935A]">Zone d'intervention</span>
              <h2 className="font-serif text-3xl lg:text-4xl text-[#0F172A] mt-4">
                Marseille &amp; Provence
              </h2>
              <p className="text-[#64748B] mt-6 leading-relaxed">
                Le cabinet intervient sur l'ensemble de Marseille et des Bouches-du-Rhône
                (Aix-en-Provence, Aubagne, La Ciotat, Marignane, Vitrolles). Pour les missions
                d'expertise judiciaire diligentées par la Cour d'appel d'Aix-en-Provence,
                notre périmètre s'étend sur l'ensemble du ressort territorial de la cour
                (Alpes-de-Haute-Provence, Alpes-Maritimes, Bouches-du-Rhône et le Var).
              </p>
            </div>
            <div>
              <span className="font-overline-lg text-[#B8935A]">L'équipe</span>
              <h2 className="font-serif text-3xl lg:text-4xl text-[#0F172A] mt-4">
                Une équipe pluridisciplinaire
              </h2>
              <p className="text-[#64748B] mt-6 leading-relaxed">
                Gestionnaires diplômés, comptables spécialisés copropriété, juristes
                immobiliers&nbsp;: chaque expertise mobilisée au bon moment, dans une organisation
                cohérente et lisible par les copropriétaires.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export function PageHero({ overline, title, subtitle }) {
  return (
    <section className="bg-[#0F172A] text-white pt-16 pb-14 sm:pt-24 sm:pb-20 lg:pt-40 lg:pb-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-overline-lg text-[#B8935A]">{overline}</span>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-6xl mt-5 sm:mt-6 max-w-4xl leading-[1.1]">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#CBD5E1] mt-5 sm:mt-6 max-w-2xl text-base sm:text-lg leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
